import { render, staticRenderFns } from "./KiPilotPraxisTasks.vue?vue&type=template&id=355a2abf&scoped=true&"
import script from "./KiPilotPraxisTasks.vue?vue&type=script&lang=ts&"
export * from "./KiPilotPraxisTasks.vue?vue&type=script&lang=ts&"
import style0 from "./KiPilotPraxisTasks.vue?vue&type=style&index=0&id=355a2abf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a2abf",
  null
  
)

export default component.exports